{
  "dismissedMessage": "Dismissed request for \"{{tailNumber}}\"",
  "dismissError": "Failed to dismiss request. Please try again.",
  "emptyState": "No pending tail number requests",
  "unknown": "Unknown",
  "headers": {
    "tailNumber": "Tail Number",
    "fboName": "FBO Name",
    "requestedBy": "Requested By",
    "requestedAt": "Requested At",
    "actions": "Actions"
  },
  "dismissTooltip": "Dismiss this request"
}
